/**
 * Paradise Health — Predictive Search Enhancement
 * Loaded when predictive search is enabled in theme settings.
 * The core logic is in global.js PredictiveSearch custom element.
 * This file handles route-based search resource configuration.
 */

(function () {
  'use strict';

  const searchElement = document.querySelector('predictive-search');
  if (!searchElement) return;

  // Enhance the search input with keyboard navigation
  const resultsContainer = searchElement.querySelector('[data-predictive-search-results]');
  const input = searchElement.querySelector('[data-predictive-search-input]');

  if (!input || !resultsContainer) return;

  input.addEventListener('keydown', (e) => {
    const links = resultsContainer.querySelectorAll('a');
    if (links.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      links[0]?.focus();
    }
  });

  resultsContainer.addEventListener('keydown', (e) => {
    const links = Array.from(resultsContainer.querySelectorAll('a'));
    const currentIndex = links.indexOf(document.activeElement);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = links[currentIndex + 1];
      if (next) next.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (currentIndex === 0) {
        input.focus();
      } else {
        const prev = links[currentIndex - 1];
        if (prev) prev.focus();
      }
    }
  });
})();
